import { B2B } from '@/components/blocks/B2B';
import { LoginChangePasswordForm } from '@/components/content/Login/parts/LoginChangePasswordForm';
import { LoginRegistrationB2BForm } from '@/components/content/Login/parts/LoginRegistrationB2BForm';
import {
	createAccountContainerSX,
	loginContainerHomeSX,
} from '@/components/content/Login/styles/container';
import { UserLogon, personMutatorKeyMatcher, useLogin } from '@/data/Content/Login';
import { CreateAccountLoginForm } from '@/components/content/Login/parts/CreateAccountLogin';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useLocalization } from '@/data/Localization';
import { ID } from '@/data/types/Basic';
import { Box, Divider, Grid, Paper, Typography } from '@mui/material';
import { FC } from 'react';
import { useSWRConfig } from 'swr';
import { SingleLoginForm } from '@/components/blocks/SingleLoginForm';
import { LoginTitleSX } from '@/components/content/Login/styles/main';
import { useIsMobile } from '@/data/hooks/useIsMobile';

export const Login: FC<{ id: ID }> = () => {
	const isMobile = useIsMobile();
	const router = useNextRouter();
	const RouteLocal = useLocalization('Routes');
	const { mutate } = useSWRConfig();

	const contentSpacingLogin = {
		xs: 2,
		sm: 2,
		md: 6,
		lg: 32.5,
	};

	const { loginSubmit, setPasswordExpired, passwordExpired } = useLogin();

	const handleLogin = async (props: UserLogon) => {
		const resp = await loginSubmit(props);
		if ('userId' in resp ?? {}) {
			if (router.query.flow === 'checkout') {
				await router.push(RouteLocal.CheckOut.route.t());
			} else {
				await router.push(RouteLocal.Account.route.t());
			}
			await mutate(personMutatorKeyMatcher(''), undefined);
		}
	};

	const onCancel = () => {
		setPasswordExpired(null);
	};

	return (
		<Grid container spacing={contentSpacingLogin} sx={{ paddingTop: { md: '0px', xs: '0px' } }}>
			<Grid item xs={12} sm={8} md={6} m="auto">
				<Paper sx={loginContainerHomeSX({ isMobile })}>
					{passwordExpired !== null ? (
						<LoginChangePasswordForm
							onSubmit={handleLogin}
							onCancel={onCancel}
							passwordExpired={passwordExpired}
						/>
					) : (
						<Box>
							<Typography sx={LoginTitleSX}>{'INICIA SESIÓN'}</Typography>
							<SingleLoginForm
								forgotPasswordPosition={isMobile ? 'bottom' : 'line'}
								onSubmit={handleLogin}
							/>
						</Box>
					)}
				</Paper>
				<Paper sx={createAccountContainerSX({ isMobile })}>
					{isMobile ? <Divider sx={{ marginBottom: '15px' }} /> : null}
					<CreateAccountLoginForm onSubmit={handleLogin} />
				</Paper>
			</Grid>
			<B2B>
				<Grid item xs={12} sm={8} md={6}>
					<LoginRegistrationB2BForm />
				</Grid>
			</B2B>
		</Grid>
	);
};
